export default {
  Active: 'Theo dõi',
  AccountingEmployee: {
    ModuleName: 'Cán bộ',
    CommonInfo: 'Thông tin chung',
    EmployeeCode: 'Mã cán bộ *',
    EmployeeName: 'Tên cán bộ *',
    Position: 'Chức vụ',
    Address: 'Địa chỉ',
    ContactInfo: 'Thông tin liên hệ',
    Department: 'Phòng ban *',
    SalaryScaleCode: 'Mã ngạch lương',
    FamilyDeductionAmount: 'Số người phụ thuộc',
    SalaryCoefficient: 'Hệ số lương',
    ContactOfficeTel: 'ĐTCQ',
    Tel: 'ĐTDĐ',
    HomeTel: 'ĐTNR',
    Email: 'Email',
    OtherInfo: 'Thông tin cá nhân',
    ContactSex: 'Giới tính',
    IdentificationNumber: 'Số CMND',
    IssueDate: 'Ngày cấp',
    IssueBy: 'Nơi cấp',
    CompanyTaxCode: 'Mã số thuế',
    BankAccount: 'Số TK cá nhân',
    BankName: 'Ngân hàng mở TK',

    TitleContactOfficeTel: 'Điện thoại cơ quan',
    TitleTel: 'Điện thoại di động',
    TitleHomeTel: 'Điện thoại nhà riêng',
    TitleIdentificationNumber: 'Số chứng minh thư/căn cước công dân',
    TitleCompanyTacCode: 'Mã số thuế thu nhập cá nhân',
    TitleBankAccount: 'Số tài khoản cá nhân',
    TitleBankName: 'Ngân hàng mở tài khoản',
    TitleBudgetCode: 'Mã quan hệ ngân sách',
  },
};
